import { ArrowBack } from '@mui/icons-material';
import { Link, Stack, Typography } from '@mui/material';
import { NotFoundError, PageLayout } from '@retail/components';
import { mgPrisRoutes } from '@retail/mgpris/config';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { PriceControlSupplierContainer } from '@retail/price-control/containers';
import { Paper } from '@shared/components';
import { useNavigate, useParams } from 'react-router';

export function PriceControlSupplierPage() {
  const t = useMyAssortmentTFunction();
  const navigate = useNavigate();
  const { supplierNumber } = useParams();

  const onReturnToOverview = () => {
    navigate(mgPrisRoutes.priceControl.getFullLinkPath());
  };

  return (
    <PageLayout maxWidth="full" fixedHeight>
      <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0 }}>
        <Link color="textPrimary" onClick={onReturnToOverview} sx={{ cursor: 'pointer' }}>
          <Stack flexDirection="row" alignItems="center" p={1} pb={0}>
            <ArrowBack fontSize="small" sx={{ height: 16 }} />
            <Typography variant="body2">{t('myAssortment.priceControl.backToOverview')}</Typography>
          </Stack>
        </Link>

        {supplierNumber ? (
          <PriceControlSupplierContainer supplierNumber={Number(supplierNumber)} />
        ) : (
          <NotFoundError />
        )}
      </Paper>
    </PageLayout>
  );
}
